/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Contact_IntroInputs */

const en_contact_intro = /** @type {(inputs: Contact_IntroInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`The fastest way to book a lesson or ask a question is by phone. Email works too. Mark will get back to you.`)
};

const es_contact_intro = /** @type {(inputs: Contact_IntroInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`La forma más rápida de reservar una lección o hacer una pregunta es por teléfono. También puedes escribir por email. Mark te responderá.`)
};

const de_contact_intro = /** @type {(inputs: Contact_IntroInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Der schnellste Weg, eine Unterrichtsstunde zu buchen oder eine Frage zu stellen, ist telefonisch. E-Mail funktioniert auch. Mark wird sich bei Ihnen melden.`)
};

const zh_contact_intro = /** @type {(inputs: Contact_IntroInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`预订课程或提问的最快方法是通过电话。也可以发电子邮件。Mark 会回复你。`)
};

const ar_contact_intro = /** @type {(inputs: Contact_IntroInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`أسرع طريقة لحجز درس أو طرح سؤال هي عبر الهاتف. البريد الإلكتروني مناسب أيضاً. سيردّ Mark عليك.`)
};

const fr_contact_intro = /** @type {(inputs: Contact_IntroInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Le moyen le plus rapide de réserver un cours ou de poser une question est par téléphone. Le courrier électronique fonctionne aussi. Mark vous répondra.`)
};

const vi_contact_intro = /** @type {(inputs: Contact_IntroInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Cách nhanh nhất để đặt buổi học hoặc đặt câu hỏi là gọi điện. Email cũng được. Mark sẽ phản hồi bạn.`)
};

const sw_contact_intro = /** @type {(inputs: Contact_IntroInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Njia ya haraka sana ya kuweka nafasi ya somo au kuuliza swali ni kwa simu. Barua pepe inafanya kazi pia. Mark atawasiliana nawe.`)
};

const th_contact_intro = /** @type {(inputs: Contact_IntroInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`วิธีที่เร็วที่สุดในการจองบทเรียนหรือถามคำถามคือทางโทรศัพท์ อีเมลก็ใช้งานได้เช่นกัน Mark จะติดต่อกลับ`)
};

const bs_contact_intro = /** @type {(inputs: Contact_IntroInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Najbrži način da rezervišete lekciju ili postavite pitanje je telefonom. Možete i putem emaila. Mark će vam se javiti.`)
};

const ja_contact_intro = /** @type {(inputs: Contact_IntroInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`レッスンのご予約やご質問は、お電話が一番早いです。メールでも承ります。Markよりご連絡いたします。`)
};

const ko_contact_intro = /** @type {(inputs: Contact_IntroInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`레슨 예약이나 문의는 전화가 가장 빠릅니다. 이메일도 가능합니다. Mark가 연락드리겠습니다.`)
};

const pt_contact_intro = /** @type {(inputs: Contact_IntroInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`A maneira mais rápida de agendar uma aula ou tirar uma dúvida é por telefone. E-mail também funciona. Mark vai retornar o seu contato.`)
};

const it_contact_intro = /** @type {(inputs: Contact_IntroInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Il modo più veloce per prenotare una lezione o fare una domanda è per telefono. Va bene anche l'email. Mark ti risponderà.`)
};

const sv_contact_intro = /** @type {(inputs: Contact_IntroInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Det snabbaste sättet att boka en lektion eller ställa en fråga är per telefon. Email fungerar också. Mark återkommer till dig.`)
};

const nl_contact_intro = /** @type {(inputs: Contact_IntroInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`De snelste manier om een les te boeken of een vraag te stellen is telefonisch. E-mail werkt ook. Mark belt je terug.`)
};

const da_contact_intro = /** @type {(inputs: Contact_IntroInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Den hurtigste måde at bestille en lektion eller stille et spørgsmål er via telefon. Email virker også. Mark ringer tilbage.`)
};

const nb_contact_intro = /** @type {(inputs: Contact_IntroInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Den raskeste måten å bestille en leksjon eller stille et spørsmål er telefonisk. E-post fungerer også. Mark tar kontakt med deg.`)
};

const fi_contact_intro = /** @type {(inputs: Contact_IntroInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Nopein tapa varata oppitunti tai kysyä kysymys on puhelimitse. Sähköpostikin toimii. Mark soittaa takaisin.`)
};

const pl_contact_intro = /** @type {(inputs: Contact_IntroInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Najszybciej zarezerwujesz lekcję lub zadasz pytanie telefonicznie. E-mail też działa. Mark oddzwoni.`)
};

const ru_contact_intro = /** @type {(inputs: Contact_IntroInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Самый быстрый способ записаться на урок или задать вопрос — позвонить. Можно и написать на электронную почту. Mark вам ответит.`)
};

const tr_contact_intro = /** @type {(inputs: Contact_IntroInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Ders ayırtmanın veya soru sormanın en hızlı yolu telefondur. E-posta da olur. Mark size dönüş yapacak.`)
};

const hi_contact_intro = /** @type {(inputs: Contact_IntroInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`पाठ बुक करने या सवाल पूछने का सबसे तेज़ तरीका फ़ोन है। ईमेल भी कर सकते हैं। Mark आपसे संपर्क करेंगे।`)
};

const id_contact_intro = /** @type {(inputs: Contact_IntroInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Cara tercepat untuk memesan pelajaran atau bertanya adalah melalui telepon. Email juga bisa. Mark akan menghubungi Anda.`)
};

const ms_contact_intro = /** @type {(inputs: Contact_IntroInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Cara paling cepat untuk menempah pelajaran atau bertanya ialah melalui telefon. E-mel juga boleh. Mark akan menghubungi anda.`)
};

const cs_contact_intro = /** @type {(inputs: Contact_IntroInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Nejrychlejší způsob, jak si rezervovat lekci nebo položit otázku, je telefonicky. Email taky funguje. Mark se vám ozve.`)
};

const el_contact_intro = /** @type {(inputs: Contact_IntroInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Ο γρηγορότερος τρόπος για να κλείσετε ένα μάθημα ή να κάνετε μια ερώτηση είναι από το τηλέφωνο. Το email δουλεύει επίσης. Ο Mark θα επικοινωνήσει μαζί σας.`)
};

const he_contact_intro = /** @type {(inputs: Contact_IntroInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`הדרך המהירה ביותר להזמין שיעור או לשאול שאלה היא בטלפון. אפשר גם בדואר אלקטרוני. Mark יחזור אליכם.`)
};

const af_contact_intro = /** @type {(inputs: Contact_IntroInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Die vinnigste manier om 'n les te bespreek of 'n vraag te vra, is per telefoon. E-pos werk ook. Mark sal by jou terugkom.`)
};

const hu_contact_intro = /** @type {(inputs: Contact_IntroInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Órát foglalni vagy kérdezni a leggyorsabban telefonon lehet. Az e-mail is működik. Mark majd visszahív.`)
};

/**
* | output |
* | --- |
* | "The fastest way to book a lesson or ask a question is by phone. Email works too. Mark will get back to you." |
*
* @param {Contact_IntroInputs} inputs
* @param {{ locale?: "en" | "es" | "de" | "zh" | "ar" | "fr" | "vi" | "sw" | "th" | "bs" | "ja" | "ko" | "pt" | "it" | "sv" | "nl" | "da" | "nb" | "fi" | "pl" | "ru" | "tr" | "hi" | "id" | "ms" | "cs" | "el" | "he" | "af" | "hu" }} options
* @returns {LocalizedString}
*/
export const contact_intro = /** @type {((inputs?: Contact_IntroInputs, options?: { locale?: "en" | "es" | "de" | "zh" | "ar" | "fr" | "vi" | "sw" | "th" | "bs" | "ja" | "ko" | "pt" | "it" | "sv" | "nl" | "da" | "nb" | "fi" | "pl" | "ru" | "tr" | "hi" | "id" | "ms" | "cs" | "el" | "he" | "af" | "hu" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Contact_IntroInputs, { locale?: "en" | "es" | "de" | "zh" | "ar" | "fr" | "vi" | "sw" | "th" | "bs" | "ja" | "ko" | "pt" | "it" | "sv" | "nl" | "da" | "nb" | "fi" | "pl" | "ru" | "tr" | "hi" | "id" | "ms" | "cs" | "el" | "he" | "af" | "hu" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "es") return es_contact_intro(inputs)
	if (locale === "de") return de_contact_intro(inputs)
	if (locale === "zh") return zh_contact_intro(inputs)
	if (locale === "ar") return ar_contact_intro(inputs)
	if (locale === "fr") return fr_contact_intro(inputs)
	if (locale === "vi") return vi_contact_intro(inputs)
	if (locale === "sw") return sw_contact_intro(inputs)
	if (locale === "th") return th_contact_intro(inputs)
	if (locale === "bs") return bs_contact_intro(inputs)
	if (locale === "ja") return ja_contact_intro(inputs)
	if (locale === "ko") return ko_contact_intro(inputs)
	if (locale === "pt") return pt_contact_intro(inputs)
	if (locale === "it") return it_contact_intro(inputs)
	if (locale === "sv") return sv_contact_intro(inputs)
	if (locale === "nl") return nl_contact_intro(inputs)
	if (locale === "da") return da_contact_intro(inputs)
	if (locale === "nb") return nb_contact_intro(inputs)
	if (locale === "fi") return fi_contact_intro(inputs)
	if (locale === "pl") return pl_contact_intro(inputs)
	if (locale === "ru") return ru_contact_intro(inputs)
	if (locale === "tr") return tr_contact_intro(inputs)
	if (locale === "hi") return hi_contact_intro(inputs)
	if (locale === "id") return id_contact_intro(inputs)
	if (locale === "ms") return ms_contact_intro(inputs)
	if (locale === "cs") return cs_contact_intro(inputs)
	if (locale === "el") return el_contact_intro(inputs)
	if (locale === "he") return he_contact_intro(inputs)
	if (locale === "af") return af_contact_intro(inputs)
	if (locale === "hu") return hu_contact_intro(inputs)
	return en_contact_intro(inputs)
});